import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=17f1bf5f&"
import script from "./TransactionsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f1bf5f')) {
      api.createRecord('17f1bf5f', component.options)
    } else {
      api.reload('17f1bf5f', component.options)
    }
    module.hot.accept("./TransactionsList.vue?vue&type=template&id=17f1bf5f&", function () {
      api.rerender('17f1bf5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/TransactionsList.vue"
export default component.exports